/** REST klient pro automatizace (node-graf). Editor (M5) na tom postaví. */

import type { AutomationGraph, GraphValidationIssue } from "@globals/automations";
import { deleteAsync, getAsync, postAsync, putAsync } from "./axios";

export type AutomationSummary = {
  id: string;
  name: string;
  description: string;
  enabled: boolean;
  legacyRuleId: number | null;
  updatedAt: string;
  version: number;
  stats: { lastEvalAt: number; evalCount: number } | null;
};

export type AutomationDetail = {
  id: string;
  userId: string;
  name: string;
  description: string;
  enabled: boolean;
  graph: AutomationGraph;
  triggerTopics: string[];
  version: number;
  legacyRuleId: number | null;
  createdAt: string;
  updatedAt: string;
};

export type AutomationTrace = {
  nodes: { nodeId: string; outputs: unknown; error?: string }[];
  fired: { nodeId: string; type: string; detail: string }[];
};

export type AutomationRunRow = {
  id: string;
  status: "OK" | "ERROR" | "TEST";
  triggeredBy: string;
  trace: unknown;
  error: string | null;
  startedAt: string;
};

export const getAutomations = () => getAsync<ApiResp<AutomationSummary[]>>("/api/automations");
export const getAutomation = (id: string) => getAsync<ApiResp<AutomationDetail>>(`/api/automations/${id}`);

export const postAutomation = (input: { name: string; description?: string; enabled?: boolean; graph: AutomationGraph }) =>
  postAsync<ApiResp<{ id: string } | GraphValidationIssue[]>>("/api/automations", input);

export const putAutomation = (
  id: string,
  input: { name: string; description?: string; enabled?: boolean; graph: AutomationGraph; version: number }
) => putAsync<ApiResp<{ version: number } | GraphValidationIssue[]>>(`/api/automations/${id}`, input);

export const enableAutomation = (id: string, enabled: boolean) =>
  postAsync<ApiResp<boolean>>(`/api/automations/${id}/enable`, { enabled });

export const deleteAutomation = (id: string) => deleteAsync<ApiResp<boolean>>(`/api/automations/${id}`);

export const testAutomation = (id: string, nodeId?: string) =>
  postAsync<ApiResp<AutomationTrace>>(`/api/automations/${id}/test`, { nodeId });

export const fireAutomationNode = (id: string, nodeId: string) =>
  postAsync<ApiResp<boolean>>(`/api/automations/${id}/fire/${nodeId}`);

export const getAutomationRuns = (id: string, limit = 50) =>
  getAsync<ApiResp<AutomationRunRow[]>>(`/api/automations/${id}/runs?limit=${limit}`);
